import React from "react";
import "../HTMate/HTMate.scss";

const Terms = () => {
  return (
    <div className="textitem">
      <h3>Hlthtek.com Terms and Conditions</h3>
      <p>
        <strong>Last Updated:</strong> 1st June 2024
      </p>

      <p>Welcome to Hlthtek.com!</p>

      <p>
        These Terms and Conditions ("Terms") govern your access and use of the
        Hlthtek.com platform, including all related services and features (the
        "Platform"). By accessing or using the Platform, you agree to be bound
        by these Terms. If you do not agree to these Terms, you may not access
        or use the Platform.
      </p>

      <div className="textitem">
        <h5>Hlthtek.com Services:</h5>
        <p>
          Hlthtek.com is a digital health platform designed to empower
          healthcare providers, patients, and payers. We offer a range of
          services, including:
        </p>
        <ul>
          <li>
            <strong>Electronic Health Records (EHR):</strong> Secure and
            user-friendly EHR tools for healthcare providers to manage patient
            records, access clinical data, and improve patient care.
          </li>
          <li>
            <strong>Health Data Interoperability:</strong> A robust platform
            that facilitates seamless sharing and exchange of health data
            between healthcare providers, patients, and payers.
          </li>
          <li>
            <strong>Preventive, Personalised, and Predictive Health:</strong>{" "}
            Innovative features and tools to promote preventive healthcare,
            personalize care plans, and leverage predictive analytics for early
            disease detection and intervention.
          </li>
          <li>
            <strong>Affordable Health and Improved Quality of Care:</strong> We
            strive to make healthcare more affordable and accessible through
            technology, enabling better communication and coordination between
            providers and patients.
          </li>
        </ul>
      </div>

      <div className="textitem">
        <h5>User Eligibility:</h5>
        <p>
          To access and use the Platform, you must be at least 18 years old and
          have the legal capacity to enter into contracts.
        </p>
      </div>
      <div className="textitem">
        <h5>User Accounts:</h5>
        <ul>
          <li>
            You are responsible for maintaining the confidentiality of your
            account credentials.
          </li>
          <li>
            You are fully responsible for all activities that occur under your
            account.
          </li>
          <li>
            You must notify Hlthtek.com immediately if you suspect any
            unauthorized use of your account.
          </li>
        </ul>
      </div>

      <div className="textitem">
        <h5>Platform Usage:</h5>
        <p>
          You agree to use the Platform only for lawful purposes and in
          accordance with these Terms.
        </p>
        <p>
          You are prohibited from using the Platform for any illegal or
          unauthorized purpose, including but not limited to:
        </p>
        <ul>
          <li>
            Violating any local, state, national, or international law or
            regulation.
          </li>
          <li>Infringing upon the intellectual property rights of others.</li>
          <li>
            Accessing or attempting to access the Platform by any means other
            than through the provided interface.
          </li>
          <li>
            Interfering with or disrupting the Platform or any server or network
            connected to the Platform.
          </li>
        </ul>
        <p>
          You are responsible for all content you upload, post, or transmit
          through the Platform.
        </p>
        <p>
          You agree not to submit any content that is unlawful, harmful,
          threatening, abusive, harassing, defamatory, obscene, or otherwise
          objectionable.
        </p>
      </div>

      <div className="textitem">
        <h5>Intellectual Property:</h5>
        <p>
          The Platform and its content, including but not limited to text,
          graphics, logos, images, and software, are protected by copyright,
          trademark, and other intellectual property laws.
        </p>
      </div>
    </div>
  );
};
export default Terms;
